import * as Sentry from '@sentry/nextjs';

/**
 * CIN-14630: the browser SDK must not be initialised before the visitor consented.
 *
 * `Sentry.init()` opens a session envelope to `*.ingest.us.sentry.io` on page load, which sent the
 * visitor's IP and user agent to a third-party processor before the consent banner had even been
 * shown (§ 25 TDDDG). Both callers therefore check consent to the analysis category first:
 * `instrumentation-client.ts` for a returning visitor who already consented, and
 * `ConsentGatedSentry` for consent granted later in the session.
 *
 * Server and edge Sentry (sentry.server.config.ts / sentry.edge.config.ts) are unaffected: those
 * run on our own infrastructure and never touch the visitor's browser.
 */
export default function initSentryClient(): void {
    // Sentry.init() is not idempotent — a second call installs a second client and double-reports.
    // The guard reads Sentry's global carrier rather than a module flag, so it holds even though
    // Next bundles the instrumentation entry separately from the app.
    if (Sentry.getClient()) {
        return;
    }

    Sentry.init({
        dsn: 'https://3f2edafc9cce132af0716e4e1c46743d@o1087176.ingest.us.sentry.io/4510322787418112',

        // Enable sending user PII (Personally Identifiable Information)
        // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
        sendDefaultPii: false
    });
}
